{
  "YOUR_FEEDBACK_SUGGESTION_HELP_IMPROVE_PRODUCT": "Your feedback and suggestions will help us improve our product and services.",
  "TECHNICAL_ISSUES_CONTACT_ADMIN_OR_SP": "If you have a technical or support issue, or require immediate assistance, please contact your Laserfiche Administrator or Solution Provider as indicated in your service agreement.",
  "FOUND_SOMETHING_LIKE_DISLIKE_LET_US_KNOW": "Found something you like or dislike? Let us know about it.",
  "DO_YOU_HAVE_IDEA_NEW_FEATURE_IMPROVEMENT_LOOK_FORWARD_TO_HEARING": "Do you have an idea for a new feature or an improvement? We look forward to hearing about it.",
  "PLEASE_DO_NOT_INCLUDE_CONFIDENTIAL_OR_PERSONAL_INFO_IN_FEEDBACK": "Please do not include any confidential or personal information in your feedback",
  "TELL_US_ABOUT_EXPERIENCE": "Tell us about your experience",
  "TELL_US_ABOUT_IDEA": "Tell us about your idea",
  "I_HAVE_FEEDBACK": "I have feedback",
  "I_HAVE_SUGGESTION": "I have a suggestion",
  "YOU_MAY_CONTACT_ME_ABOUT_FEEDBACK": "You may contact me about this feedback",
  "IF_YOUD_LIKE_TO_JOIN_OUR_CUSTOMER_PANEL": "If you'd like to join our Customer Panel,",
  "PLEASE_CLICK_HERE": "please click here.",
  "IMAGE_EXCEEDS_MAX_FILE_SIZE_0": "The image exceeds the maximum file size of {0}.",
  "IMAGE_CORRUPTED_UNRECOGNIZED_FORMAT": "The image is corrupted or in an unrecognized format.",
  "ACCEPTED_FORMATS_ARE_0": "The accepted formats are: {0}.",
  "IMAGE_NOT_ATTACHED": "Image not attached.",
  "ATTACH_IMAGE": "Attach Image",
  "PLEASE_ATTACH_ONLY_ONE_IMAGE": "Please attach only one image.",
  "TAGS": "Tags",
  "ADD_TAGS": "Add tags",
  "ADD_MORE_TAGS": "Add more tags",
  "NO_TAGS_AVAILABLE": "No tags available"
}
